module.exports = __webpack_public_path__ + "2e6bce67c211cc7016a85ac67d3960cf.MP3";